export const testWords = [
  {
    text: 'ДОСТИЖЕНИЕ РЕЗУЛЬТАТА НЕВОЗМОЖНО В ОДИНОЧКУ',
    value: 1,
  },
  {
    text: 'НАЦЕЛЕННОСТЬ НА РЕЗУЛЬТАТ!',
    value: 2,
  },
  {
    text: 'МЫ БУДЕМ ЛУЧШИМИ!',
    value: 1,
  },
  {
    text: 'КОМАНДНОСТЬ И ПАРТНЕРСТВО',
    value: 3,
  },
  {
    text: 'ЕДИНЕНИЕ',
    value: 1,
  },
  {
    text: 'ВДОХНОВЛЯЕТ',
    value: 5,
  },
  {
    text: 'СМЫСЛ',
    value: 1,
  },
  {
    text: 'МЫ - КОМАНДА!',
    value: 100,
  },
  {
    text: 'АМБИЦИОЗНОСТЬ И ЖЕЛАНИЕ ДОСТИЖЕНИЯ ЦЕЛЕЙ',
    value: 7,
  },
  {
    text: 'УВЕРЕННОСТЬ',
    value: 1,
  },
  {
    text: 'ДОВЕРИЕ',
    value: 10,
  },
  {
    text: 'КОМАНДА',
    value: 1,
  },
  {
    text: 'ВМЕСТЕ!',
    value: 29,
  },
  {
    text: 'СИЛА В КОМАНДЕ',
    value: 1,
  },
  {
    text: 'СИЛА КОМАНДЫ',
    value: 55,
  },
  {
    text: 'ПАРТНЕРСТВО',
    value: 1,
  },
  {
    text: 'ПОБЕДА',
    value: 45,
  },
  {
    text: 'СИЛА В ЕДИНСТВЕ',
    value: 1,
  },
  {
    text: 'ВООДУШЕВЛЕНИЕ',
    value: 23,
  },
  {
    text: 'УСПЕХ',
    value: 1,
  },
  {
    text: 'ВСЕ ПОЛУЧИТСЯ',
    value: 1,
  },
  {
    text: 'КОМАНДНЫЙ ДУХ',
    value: 54,
  },
  {
    text: 'ВМЕСТЕ',
    value: 1,
  },
  {
    text: 'ЕДИНСТВО',
    value: 1,
  },
  {
    text: 'СИЛА В КОМАНДЕ',
    value: 58,
  },
  {
    text: 'ВЕРА В КОМАНДУ',
    value: 1,
  },
  {
    text: 'МЫ КОМАНДА',
    value: 1,
  },
  {
    text: 'КОМАНДА РЕШАЕТ!!!',
    value: 1,
  },
  {
    text: 'КОМАНДА - СИЛА',
    value: 22,
  },
  {
    text: 'ВДОХНОВЕНИЕ',
    value: 1,
  },
  {
    text: 'ЭНЕРГИЮ КОМАНДЫ!',
    value: 1,
  },
  {
    text: 'СМОЖЕМ',
    value: 53,
  },
  {
    text: 'ЛЮДИ СБЕРА-СИЛА!',
    value: 1,
  },
  {
    text: 'МОТИВАЦИЯ, ЗАРЯД ЭНЕРГИИ!',
    value: 1,
  },
  {
    text: 'ЗАРЯД',
    value: 1,
  },
  {
    text: 'МОТИВАЦИЯ!',
    value: 1,
  },
  {
    text: 'ВСЕ ВОЗМОЖНО',
    value: 1,
  },
  {
    text: 'ЗАРЯД ЭНЕРГИИ',
    value: 1,
  },
  {
    text: 'ЛЮДИ ЭТО ГЛАВНОЕ',
    value: 1,
  },
  {
    text: 'КОМАНДНАЯ РАБОТА И СПЛОЧЕНИЕ',
    value: 1,
  },
  {
    text: 'МОТИВАЦИЯ',
    value: 1,
  },
  {
    text: 'ОБЩЕНИЕ',
    value: 1,
  },
  {
    text: 'ЛИДЕРСТВО',
    value: 1,
  },
  {
    text: 'ТОЛЬКО ВПЕРЕД!',
    value: 1,
  },
  {
    text: 'МЫ СИЛЬНАЯ КОМАНДА!!!',
    value: 1,
  },
  {
    text: 'ПОРА ДОГОВАРИВАТЬСЯ!',
    value: 1,
  },
  {
    text: 'СИЛА В КОМАНДЕ, КОМАНДЕ ПРОФЕССИОНАЛОВ!',
    value: 1,
  },
  {
    text: 'ВЗАИМОПОМОЩЬ',
    value: 1,
  },
  {
    text: 'ВКУС ПОБЕДЫ!',
    value: 1,
  },
  {
    text: 'ДОВЕРЯТЬ КОМАНДЕ',
    value: 1,
  },
  {
    text: 'НАСТАВНИЧЕСТВО ЭФФЕКТИВНОСТЬ БЛАГОДАРНОСТЬ',
    value: 1,
  },
  {
    text: 'ВАЖНОСТЬ КОМАНДНОЙ РАБОТЫ',
    value: 1,
  },
  {
    text: 'БЫТЬ ВМЕСТЕ=БЫТЬ СИЛЬНЕЕ!',
    value: 1,
  },
  {
    text: 'УВЕРЕННОСТЬ, ЧТО ВСЕ ПОЛУЧИТСЯ',
    value: 1,
  },
  {
    text: 'ВАЖНО ДУМАТЬ СООБЩА И ДЕЛАТЬ ВМЕСТЕ',
    value: 1,
  },
  {
    text: 'ВМЕСТЕ-СМОЖЕМ ВСЕ',
    value: 100,
  },
];
